import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-limit-modal',
  templateUrl: './limit-modal.component.html',
  styleUrl: './limit-modal.component.scss'
})
export class LimitModalComponent {
  constructor(
    public dialogRef: MatDialogRef<LimitModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  close() {
    this.dialogRef.close();
  }

  upgrade() {
    this.dialogRef.close(true);
  }
}
